import React, {useState, useContext} from 'react';
import Col from 'react-bootstrap/Col';
import {parse} from 'date-fns';
import { LabelText } from '../../../components/Language';
import { OverviewContext } from '../../context/OverviewProvider';
import Aux from '../../../hoc/Auxiliary';
import CalendarFooter from '../../../components/UI/CalendarFooter/CalendarFooter';
import {OverviewDetailsOptions} from '../../../common/const/OverviewDetailsOptions';
import './index.css';

export default function OverviewFooter(props) {
    const fromRevenueDate= props.fromRevenueDate && parse(props.fromRevenueDate, "dd/MM/yyyy", new Date());
    const untilRevenueDate= props.untilRevenueDate && parse(props.untilRevenueDate, "dd/MM/yyyy", new Date());
    const [fromDate, setFromDate] = useState(fromRevenueDate);
    const [untilDate, setUntilDate] = useState(untilRevenueDate);
    const { selectedOverdetailsOption, handlerSelectedOptionChange, overview, isBtnDetailsEnable, handlerOnShowDetail } 
            = useContext(OverviewContext);

    const fromDateChangeHandler = (date) => {        
        if (date )
        {
          if( untilDate < date)    
          {
            props.onFromDateChange(date, true, "From Date should not be greator than Until Date");
          }
          else
          {
            setFromDate(date);
            props.onFromDateChange(date, false, "");
          } 
        }      
    }
    
    const untilDateChangeHandler = (date) => {
        if(date) 
        {
           if (fromDate> date)    
            {
            props.onUntilDateChange(date,true, "Until Date should not be less than From Date");
            }
            else
            {
            setUntilDate(date);
            props.onUntilDateChange(date, false, "");
            }  
        }           
    }

    const overviewDetailsOptionChangeHandler = (ev) => {
        handlerSelectedOptionChange(ev.target.value)
    }

    return (         
        <Aux> 
            <div className="Overview-footer-main">           
                <CalendarFooter fromDate={fromDate} untilDate={untilDate}
                    fromMinDate={props.fromMinDate} 
                    fromMaxDate={props.fromMaxDate} 
                    untilMinDate={props.untilMinDate} 
                    untilMaxDate={props.untilMaxDate} 
                    fromDateChangeHandler={fromDateChangeHandler}
                    untilDateChangeHandler={untilDateChangeHandler}
                />
                <Col>
                    <div className="Overview-header-col-right">
                        <div className="Overview-header-col-right-container">
                            <div className="Overview-header-col-options">                            
                                <div className="radio">
                                    <label>
                                        <input type = "radio" name = "overdetailsOption" id = "overdetailsSr" value = {OverviewDetailsOptions.submittedRevenue}
                                        checked={selectedOverdetailsOption === OverviewDetailsOptions.submittedRevenue} onChange={(ev)=>overviewDetailsOptionChangeHandler(ev)} 
                                        /> <LabelText tid="submitted_revenue" />
                                    </label>
                                </div>
                                <div className="radio">
                                    <label>
                                        <input type = "radio" name = "overdetailsOption" id = "overdetailsUsr" value = {OverviewDetailsOptions.unsubmittedRevenue} 
                                        checked={selectedOverdetailsOption === OverviewDetailsOptions.unsubmittedRevenue} onChange={(ev)=>overviewDetailsOptionChangeHandler(ev)} 
                                        /> <LabelText tid="unsubmitted_revenue" />
                                    </label>
                                </div>
                            </div>                        
                        </div>                
                    </div>                
                </Col>   
                <Col>
                    {
                        overview && overview.length > 0 && 
                        <div className="Overview-header-col-btn">
                        <span><button className={!isBtnDetailsEnable ? "showDetail-btn showDetail-btn-disable" : "showDetail-btn"}
                            disabled={!isBtnDetailsEnable} onClick={handlerOnShowDetail}>
                            <LabelText tid="ShowDetail" />
                            </button></span> 
                        </div>
                        }
                </Col>             
            </div>         
        </Aux>       
    );
}


